import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=05b18cba&scoped=true"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"
import style0 from "./popover.vue?vue&type=style&index=0&id=05b18cba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b18cba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b18cba')) {
      api.createRecord('05b18cba', component.options)
    } else {
      api.reload('05b18cba', component.options)
    }
    module.hot.accept("./popover.vue?vue&type=template&id=05b18cba&scoped=true", function () {
      api.rerender('05b18cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/popover/popover.vue"
export default component.exports